import request from '@/utils/request'

let SupplyApi = {
  /*供应商列表*/
   supplyList(data, errorback) {
    return request._post('/shop/plus.supply.supply/index', data, errorback);
  },
  /*添加供应商*/
  addSupply(data, errorback) {
    return request._post('/shop/plus.supply.supply/add', data, errorback);
  },
  /*获取供应商数据*/
  getSupply(data, errorback) {
    return request._get('/shop/plus.supply.supply/edit', data, errorback);
  },
    /*角色列表*/
    roleLists(data, errorback) {
      return request._post('/shop/auth.role/index', data, errorback);
    },
  /*保存供应商*/
  saveSupply(data, errorback) {
    console.log(data)
    return request._post('/shop/plus.supply.supply/edit', data, errorback);
  },
  /*删除供应商*/
  delSupply(data, errorback) {
    return request._post('/shop/plus.supply.supply/delete', data, errorback);
  },
  /*查看商品*/
  seeSupply(data, errorback) {
    return request._post('/shop/plus.supply.supply/see', data, errorback);
  },

  /*等级列表*/
  gradeLists(data, errorback) {
    return request._post('/shop/plus.supply.grade/index', data, errorback);
},
/*添加等级*/
addgrade(data, errorback) {
    return request._post('/shop/plus.supply.grade/add', data, errorback);
},
/*修改等级*/
editGrade(data, errorback) {
    return request._post('/shop/plus.supply.grade/edit', data, errorback);
},
/*删除等级*/
deletegrade(data, errorback) {
    return request._post('/shop/plus.supply.grade/delete', data, errorback);
},

  /*保存设置*/
  saveSetting(data, errorback) {
    return request._post('/shop/plus.supply.Setting/index', data, errorback);
  },
  /*获取设置*/
  getSetting(data, errorback) {
    return request._get('/shop/plus.supply.Setting/index', data, errorback);
  },
  /*获取设置*/
    getDiySkill(data, errorback) {
    return request._post('/shop/plus.supply.supply/getDiyProduct', data, errorback);
},
}
export default SupplyApi;



// WEBPACK FOOTER //
// ./src/api/supply.js